var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H25.9934C33.7254 0 39.9934 6.26801 39.9934 14V25.9934C39.9934 33.7254 33.7254 39.9934 25.9934 39.9934H14C6.26801 39.9934 0 33.7254 0 25.9934V14Z",
    fill: "#F0FDF4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8028_325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4962 19.9967H18.3302",
    stroke: "#00A63E",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4962 16.6639H18.3302",
    stroke: "#00A63E",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.829 24.1627V14.1643C25.829 13.7224 25.6534 13.2985 25.3409 12.986C25.0284 12.6735 24.6046 12.4979 24.1626 12.4979H13.3311",
    stroke: "#00A63E",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6638 27.4955H26.6622C27.1042 27.4955 27.528 27.3199 27.8405 27.0074C28.153 26.6949 28.3286 26.271 28.3286 25.8291V24.9959C28.3286 24.7749 28.2408 24.563 28.0846 24.4067C27.9283 24.2504 27.7164 24.1627 27.4954 24.1627H19.1634C18.9425 24.1627 18.7305 24.2504 18.5743 24.4067C18.418 24.563 18.3302 24.7749 18.3302 24.9959V25.8291C18.3302 26.271 18.1547 26.6949 17.8422 27.0074C17.5297 27.3199 17.1058 27.4955 16.6638 27.4955ZM16.6638 27.4955C16.2219 27.4955 15.798 27.3199 15.4855 27.0074C15.173 26.6949 14.9975 26.271 14.9975 25.8291V14.1643C14.9975 13.7224 14.8219 13.2985 14.5094 12.986C14.1969 12.6735 13.773 12.4979 13.3311 12.4979C12.8891 12.4979 12.4653 12.6735 12.1527 12.986C11.8402 13.2985 11.6647 13.7224 11.6647 14.1643V15.8307C11.6647 16.0517 11.7525 16.2636 11.9087 16.4199C12.065 16.5761 12.2769 16.6639 12.4979 16.6639H14.9975",
    stroke: "#00A63E",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8028_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9967,
    height: 19.9967,
    fill: "white",
    transform: "translate(9.99829 9.99835)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/policy.6e0dd9354e67c869039eb192a74b61e7.svg";
export { ForwardRef as ReactComponent };